import { LocalStorageService } from 'angular-2-local-storage';
import { Injectable, isDevMode } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LocationService } from './location.service';
import { Notification } from '../interfaces/notification';

import { interval, ReplaySubject, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import { version } from '../environments/version';
import { buildDate } from '../environments/version';

@Injectable()
export class ReleaseService {

	public releaseNotificationSubject: ReplaySubject<Notification>;

	public release: string = version;
	public buildDate: string = buildDate;
	private interval: Subscription;
	private versionNotification: Notification;
	private refreshTime = 900000; // 15 minutes

	constructor(private locationService: LocationService,
		private localStorageService: LocalStorageService,
		private http: HttpClient,
		private translate: TranslateService) {
		this.releaseNotificationSubject = new ReplaySubject<Notification>(1);

		// Check every x minutes for an update.
		this.interval = interval(this.refreshTime).subscribe(() => {
			this.checkOvpVersion();
		});
		this.checkOvpVersion(true);
	}

	private checkOvpVersion(firstCheck?: boolean) {
		if (isDevMode()) {
			// don't refresh if we're in dev mode
			return;
		}
		this.http.get(this.locationService.server + '/ovp/resources/version.txt?' + Date.now(), {responseType: 'text'}).subscribe((ovpVersion: string) => {
			// console.warn('this.release', this.release, 'release', release, this.release === release);
			if (this.release && ovpVersion && this.release.trim() !== ovpVersion.trim()) {
				// check if we are on a non-HEAD branch and the dev server is:
				if (this.release.indexOf('HEAD') === -1 && ovpVersion.indexOf('HEAD') === 0) {
					// console.warn(`ReleaseService: Not refreshing because we are checking with the
					// deployed HEAD branch. (${this.release} vs ${release})`);
				} else {
					if (firstCheck) {
						const localLastRefreshDate = this.localStorageService.get('ovp-last-refresh-date');
						const lastRefreshMS = Number(localLastRefreshDate);
						if (localLastRefreshDate && Date.now() - lastRefreshMS > this.refreshTime) {
							this.localStorageService.set('ovp-last-refresh-date', Date.now());
							this.locationService.reload();
						} else if (!localLastRefreshDate) {
							this.localStorageService.set('ovp-last-refresh-date', Date.now());
						}
					} else {
						this.versionNotification = {
							group: this.translate.instant('VERSION_UPDATE'),
							label: this.translate.instant('VERSION_UPDATE_SUMMARY'),
							date: new Date(),
							entityId: 0,
							entityUrl: ''
						};
						this.releaseNotificationSubject.next(this.versionNotification);
					}
				}
				this.interval.unsubscribe();
			}
		});
	}
}
